// App utils
import { datajs, hasScollState, trapFocus } from '../shared/utils';

export default class SiteHeaderSearchToggle {
	static init() {
		const toggleSiteHeaderSearchBtn = datajs('site-header-search-toggle');
		const toggleMenuElement = datajs('toggle-off-canvas-section');
		const siteHeaderSearchInput = datajs('site-header-search-input');
		let isTransitioning = false;
		let isVisible = false;

		const toggleSiteHeaderSearch = () => {
			if (isVisible) {
				window.requestAnimationFrame(hideSiteHeaderSearch);
			} else {
				window.requestAnimationFrame(showSiteHeaderSearch);
			}
		};

		const showSiteHeaderSearch = () => {
			if (isTransitioning) {
				return false;
			}

			isTransitioning = true;

			trapFocus(document.getElementById('site-header-search-section'));
			toggleSiteHeaderSearchBtn.setAttribute('aria-expanded', 'true');

			// Transition CSS class 1
			document.body.classList.add('has-activated-siteHeaderSearch');

			// Transition CSS class 2
			setTimeout(function () {
				document.body.classList.add('has-siteHeaderSearch');

				if (hasScollState()) {
					document.body.classList.remove('is-scrollingUp');
				}

				siteHeaderSearchInput.focus();
				isVisible = true;
				isTransitioning = false;
			}, 10);

			return false;
		};

		const hideSiteHeaderSearch = () => {
			if (isTransitioning) {
				return false;
			}

			isTransitioning = true;

			toggleSiteHeaderSearchBtn.setAttribute('aria-expanded', 'false');

			// Remove Transition CSS class 2
			document.body.classList.remove('has-siteHeaderSearch');

			if (hasScollState()) {
				document.body.classList.add('is-scrollingUp');
			}

			// Remove Transition CSS class 1
			setTimeout(function () {
				document.body.classList.remove('has-activated-siteHeaderSearch');
				isVisible = false;
				isTransitioning = false;
			}, 650);

			return false;
		};

		const handleDocumentKeyUp = (e) => {
			// Close menu using Esc key.
			if (e.keyCode === 27) {
				hideSiteHeaderSearch();
			}
		};

		// Show off canvas menu
		if (toggleSiteHeaderSearchBtn) {
			toggleSiteHeaderSearchBtn.addEventListener('click', toggleSiteHeaderSearch);

			// Hide site header search if off canvas overlay is activated
			toggleMenuElement.addEventListener('click', hideSiteHeaderSearch);

			// Handle document keyup event
			document.addEventListener('keyup', handleDocumentKeyUp);
		}
	}
}
